module.exports = __webpack_public_path__ + "media/images/alteryx-homepage-ae784d6610d92fa167e143ba7f1a45bfba373054b24dded3a1ee0ef5576f21eb.png";